import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ShoppingCart, Menu, X, Phone, Mail } from 'lucide-react';
import { useCart } from '../../store/cartContext';
import { Button } from '../ui/button';
import brandLogo from '@/assets/logo.png';

export const Header = () => {
  const { totalItems, openCart } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const navLinks = [
    { to: '/#pocetna-vrh', label: 'Početna', matchPath: '/' },
    { to: '/proizvodi', label: 'Proizvodi', matchPath: '/proizvodi' },
    { to: '/kontakt#kontakt-forma', label: 'Kontakt', matchPath: '/kontakt' },
  ];

  return (
    <>
      {/* Main header */}
      <header
        className={`sticky top-0 z-50 transition-shadow duration-300 ${
          scrolled ? 'shadow-elevated bg-card/98 backdrop-blur-sm' : 'bg-card'
        } border-b border-border`}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16 md:h-20">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-3 group">
              <img
                src={brandLogo}
                alt="Sjenički proizvodi Fazlić"
                className="h-12 md:h-14 w-auto shrink-0 object-contain"
              />
              <div className="hidden sm:block">
                <div className="font-serif text-base font-semibold text-foreground leading-tight">Sjenički Proizvodi</div>
                <div className="font-serif text-xs text-gold italic">Fazlić</div>
              </div>
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden md:flex items-center gap-8">
              {navLinks.map(link => (
                (() => {
                  const isContact = link.label === 'Kontakt';
                  const isActive = location.pathname === link.matchPath;
                  return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`font-ui text-sm font-medium transition-colors duration-200 relative group ${
                    isContact
                      ? 'text-gold hover:text-gold'
                      : isActive
                        ? 'text-primary'
                        : 'text-foreground/70 hover:text-foreground'
                  }`}
                >
                  {link.label}
                  <span className={`absolute -bottom-1 left-0 h-0.5 bg-gold transition-all duration-300 ${
                    isContact ? 'w-0' : isActive ? 'w-full' : 'w-0 group-hover:w-full'
                  }`} />
                </Link>
                  );
                })()
              ))}
            </nav>

            {/* Right actions */}
            <div className="flex items-center gap-2">
              <Button
                variant="ghost"
                size="sm"
                className="relative p-2 hover:bg-accent"
                onClick={openCart}
              >
                <ShoppingCart size={20} className="text-foreground" />
                {totalItems > 0 && (
                  <span className="absolute -top-1 -right-1 h-5 w-5 rounded-full bg-primary text-primary-foreground text-xs flex items-center justify-center font-ui font-semibold">
                    {totalItems > 9 ? '9+' : totalItems}
                  </span>
                )}
              </Button>

              <Button
                variant="ghost"
                size="sm"
                className="md:hidden p-2"
                onClick={() => setMobileOpen(!mobileOpen)}
              >
                {mobileOpen ? <X size={20} /> : <Menu size={20} />}
              </Button>
            </div>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden border-t border-border bg-card pb-4">
            <nav className="flex flex-col px-4 pt-3 gap-1">
              {navLinks.map(link => (
                (() => {
                  const isContact = link.label === 'Kontakt';
                  const isActive = location.pathname === link.matchPath;
                  return (
                <Link
                  key={link.to}
                  to={link.to}
                  className={`font-ui text-sm font-medium py-2.5 px-3 rounded-lg transition-colors ${
                    isContact
                      ? 'text-gold hover:text-gold'
                      : isActive
                      ? 'bg-accent text-primary'
                      : 'text-foreground hover:bg-muted'
                  }`}
                >
                  {link.label}
                </Link>
                  );
                })()
              ))}
              <div className="mt-3 pt-3 border-t border-border text-xs text-muted-foreground font-ui space-y-1.5">
                <div className="flex items-center gap-2"><Phone size={12} /> +381601140402</div>
                <div className="flex items-center gap-2"><Mail size={12} /> drndicnermina3@gmail.com</div>
              </div>
            </nav>
          </div>
        )}
      </header>
    </>
  );
};
